import { removeProgressAnchor } from '@/shared/lib/progress';
import type { Job } from '../job-queue.types';

// ===== JOB DISAPPEARANCE PROTECTION =====
// Cache of last seen processing jobs to prevent temporary disappearance
export const lastProcessingJobs: Map<string, { job: Job; timestamp: number }> =
  new Map();
export const PROCESSING_JOBS_RETENTION_MS = 60 * 1000; // Keep processing jobs for 60 seconds

/**
 * Forget a job that reached a terminal state (completed / failed / cancelled)
 * or that the server no longer knows: drop it from the disappearance cache and
 * its progress anchor. Every terminal path goes through here — a terminal job
 * left in `lastProcessingJobs` is re-inserted with its old active status by
 * the next `replaceJobQueue` snapshot that omits it, resurrecting a failed
 * render as "processing" for up to PROCESSING_JOBS_RETENTION_MS.
 */
export function forgetActiveJob(jobId: string) {
  lastProcessingJobs.delete(jobId);
  removeProgressAnchor(jobId);
}

/**
 * Validate job data from backend
 * Ensures required fields exist before updating store
 */
export function validateJobData(jobs: Job[]): boolean {
  if (!Array.isArray(jobs)) {
    return false;
  }

  // Check for required fields in each job
  return jobs.every(
    (job) =>
      typeof job.id === 'string' &&
      typeof job.status === 'string' &&
      typeof job.jobType === 'string' &&
      typeof job.conceptId === 'string' &&
      typeof job.projectId === 'string'
  );
}
